import { PageHeader } from "@/components/PageHeader";
import { FaqSection } from "@/components/sections/FaqSection";
import { CtaBanner } from "@/components/sections/CtaBanner";

export default function Faq() {
  return (
    <div data-testid="faq-page">
      <PageHeader
        eyebrow="Help Center"
        title={<>Questions? <span className="text-brand-red">We've got answers.</span></>}
        sub="Everything families ask before they buy — and if you don't see your question, a specialist is one call away."
      />
      <FaqSection />
      <CtaBanner />
    </div>
  );
}
